<template>
  <main>
    <div class="mainContainer">
      <TheHeader />
      <div class="mainFrame">
        <OuluportBackground />
        <LoginViewLoginFrame />
      </div>
      <TheFooter />
    </div>
  </main>
</template>

<script lang="ts">
import LoginViewLoginFrame from '@/components/login/LoginViewLoginFrame.vue'
import OuluportBackground from '@/components/login/LoginViewBackground.vue'
import { defineComponent, computed } from 'vue'
import { useRegistrationsStore } from '@/stores/registrationState'

export default defineComponent({
  name: 'LoginView',
  components: {
    OuluportBackground,
    LoginViewLoginFrame
  },
  setup() {
    const registrationStore = useRegistrationsStore()
    const handleLogin = () => {
      registrationStore.setRegistered()
    }
    const isRegistered = computed(() => {
      const t = registrationStore.isRegistered
      return t
    })
    return {
      isRegistered,
      handleLogin
    }
  }
})
</script>

<style scoped>
.mainContainer {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
.mainFrame {
  width: 100%;
  flex: 1;
  color: var(--app-black);
}
</style>
